import React from "react";
import "../Style/footer.css";

function FooterBottom() {
  return (
    <div className="footerbottom">
      <div className="ftb_top">
        <input readOnly type="text" />
        <button>Search</button>
      </div>
      <div className="ftb-bottom">
        <span>
          <b>
            <a href="">₦airaland</a>
          </b>{" "}
          - Copyright © 2005 - 2024 <a href="">Oluwaseun Osewa</a>. All rights
          reserved. See <a href="">How To Advertise</a>. 3
        </span>
        <span>
          <b>Disclaimer</b>: Every Nairaland member is <b>solely responsible</b>{" "}
          for <b>anything</b> that he/she <b>posts</b> or <b>uploads</b> on
          Nairaland.
        </span>
      </div>
    </div>
  );
}

export default FooterBottom;
